import { TelerikReportViewer } from "@progress/telerik-react-report-viewer";
import { useEffect, useState } from "react";
import Footer from "./Footer";
import eventHandler from "../utils/eventHandler";
import { getServiceUrl } from "../../ProductsModule/utils/reportsUtils";
import { Spinner } from "../../SharedModule/components/Spinner";
import { BiLeftArrowAlt } from "react-icons/bi";
import { Link } from "react-router";
import { useSelector } from "react-redux";
import { checkTokenExpired } from "../redux/reducers/auth.reducer";

export const TelerikReport = ({
  title,
  reportName,
  parameters,
  parametersAreaVisible,
  backButtonText,
  backButtonRoute,
  buttonAction,
  buttonActionLabel,
  hidePagination = false,
}: {
  title: string;
  reportName: string;
  parameters?: any;
  parametersAreaVisible: boolean;
  backButtonText?: string;
  backButtonRoute?: string;
  buttonAction?: Function;
  buttonActionLabel?: string;
  hidePagination?: boolean;
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const [isLoading, setIsLoading] = useState(false);

  const isTokenExpired = useSelector(checkTokenExpired);
  if (isTokenExpired) {
    eventHandler.dispatch("authLogin", {});
  }

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    };

    eventHandler.on("toggleLeftNavBarFixed", () => {
      setIsLoading(true);
      handleResize();
    });
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      eventHandler.remove("toggleLeftNavBarFixed", null);
    };
  }, [screenWidth]);

  const topReport: string = backButtonRoute ? "110px" : "60px";
  const heightReport: string = backButtonRoute ? "83vh" : "93vh";

  const styles = {
    position: "absolute",
    left: "5px",
    right: "5px",
    top: topReport,
    bottom: "5px",
    overflow: "hidden",
    clear: "both",
    margin: "0 auto 5%",
    height: heightReport,
    width: screenWidth > 1440 ? "80%" : "90%",
  };

  // found all pagination buttons and 2nd separator, hide parent for button group
  const hidePaginationButtons = (toolbar) => {
    const goToFirstPage = toolbar.querySelector(
      "[data-command='goToFirstPage']"
    );
    const kToolbarItem = toolbar.querySelector(".k-toolbar-item");
    const goToNextPage = toolbar.querySelector(
      "[data-command='goToNextPage']"
    );
    const allSeparators = toolbar.querySelectorAll(
      ".k-toolbar-separator.k-separator"
    );
    if (goToFirstPage) goToFirstPage.parentElement.style.display = "none";
    if (goToNextPage) goToNextPage.parentElement.style.display = "none";
    if (kToolbarItem) kToolbarItem.style.display = "none";
    if (allSeparators) allSeparators[1].style.display = "none";
  };

  // function to customise telerik toolbar
  const handleViewerCreated = (viewer) => {
    setTimeout(() => {
      // find telerik toolbar element
      const toolbar = viewer?.el?.querySelector(".trv-toolbar");
      if (!toolbar) {
        return;
      }
      // Hide paginations buttons
      if (hidePagination) {
        hidePaginationButtons(toolbar);
      }
    }, 300);
  };

  return (
    <div className="content" style={{ height: "110vh" }}>
      {backButtonRoute && (
        <div className="mt-2 button-header">
          <Link
            className="back-button-container text-decoration-none"
            to={backButtonRoute}
          >
            <BiLeftArrowAlt className="back-button-arrow" />
            <span className="back-button-text">{backButtonText}</span>
          </Link>
        </div>
      )}
      <div className="button-header">
        <h2>{title}</h2>
        {buttonAction && buttonActionLabel && (
          <button
            className="btn btn-primary ms-5"
            onClick={() => buttonAction()}
          >
            {buttonActionLabel}
          </button>
        )}
      </div>

      {isLoading && (
        <div className="mt-5">
          <Spinner
            style={{
              marginLeft: "50%",
              marginTop: "5%",
            }}
          />
        </div>
      )}

      {!isLoading && (
        <TelerikReportViewer
          serviceUrl={getServiceUrl()}
          authenticationToken={parameters?.Auth ?? ""}
          reportSource={{
            report: reportName,
            parameters: parameters ?? {},
          }}
          viewerContainerStyle={styles}
          viewMode="INTERACTIVE"
          scaleMode="SPECIFIC"
          scale={0.8}
          enableAccessibility={false}
          sendEmail={{ enabled: false }}
          parametersAreaVisible={parametersAreaVisible}
          ref={handleViewerCreated}
        />
      )}

      <Footer isReport={true} />
    </div>
  );
};
